import { config as loadDotenv } from 'dotenv'
import { getBrowserUser, persistUserBrowser } from 'lib/BrowserStorage'
import { UnauthorizedView } from 'pages/UnauthorizedView'
import React, { useEffect } from 'react'
import { AppContext } from 'state/context'
import { useAppReducer } from 'state/reducer'
import { AppRouter } from '../AppRouter'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
loadDotenv()

export const App = () => {
  const value = useAppReducer()
  const { id , authToken } = getBrowserUser()
  useEffect(() => persistUserBrowser(id, authToken), [id, authToken])

  return (
    <AppContext.Provider value={value}>
      {authToken ? <AppRouter /> : <UnauthorizedView />}
      <ToastContainer />
    </AppContext.Provider>
  )
}
